﻿window.searchform = (function () {
	let start = function () {
		let input = document.getElementById("query");
		input.addEventListener("keypress", function (event) {
			if (event.key === "Enter") {
				event.preventDefault();
				validateform();
			}
		});
	};

	let validateform = function () {
		let input = document.getElementById("query");
		if (input.value.length > 0 && (input.value[0] === '?' || input.value[0] === '*')) {
			input.value = '%' + input.value.substring(1);
		}

		let searchForm = document.getElementById('searchForm');
		searchForm.submit();
	}

	return _ = {
		start: start,
		validateform: validateform
	}
})();


